<div class="inline" *ngIf="show && isLoading" data-cy="file-manager-image-loading">
  <img *ngIf="height"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-height.px]="height"
       src="assets/Images/defaultPatient.PNG"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-loading-height" />
  <img *ngIf="width"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-width.px]="width"
       src="assets/Images/defaultPatient.PNG"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-loading-width" />
</div>
<div class="inline" *ngIf="show && !isLoading && sanitizedURL && isImage" data-cy="file-manager-image-image">
  <img *ngIf="height && !maxWidth"
       [style.max-height.px]="height"
       [class.roundcorners]="roundCorners" [class.round]="roundImage" 
       [src]="sanitizedURL"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-height" />
  <img *ngIf="width && !maxHeight"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-width.px]="width"
       [src]="sanitizedURL"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-width" />
  <img *ngIf="height && maxWidth && !width"
       [style.max-width.px]="maxWidth"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-height.px]="height"
       [src]="sanitizedURL"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-height-max-width" />
  <img *ngIf="width && maxHeight"
       [style.max-width.px]="width"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-height.px]="maxHeight"
       [src]="sanitizedURL"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-width-max-height" />
</div>
<div class="inline" *ngIf="show && !isLoading && sanitizedURL && !isImage" data-cy="file-manager-image-file">
  <img *ngIf="height && !maxWidth"
       [style.max-height.px]="height"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       src="assets/Images/File.PNG"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-file-height" />
  <img *ngIf="width && !maxHeight"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-width.px]="width"
       src="assets/Images/File.PNG"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-file-width" />
  <img *ngIf="height && maxWidth"
       [style.max-width.px]="maxWidth"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-height.px]="height"
       src="assets/Images/File.PNG"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-file-height-max-width" />
  <img *ngIf="width && maxHeight"
       [style.max-width.px]="width"
       [class.roundcorners]="roundCorners" [class.round]="roundImage"
       [style.max-height.px]="maxHeight"
       src="assets/Images/File.PNG"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image"
       data-cy="file-manager-image-file-width-max-height" />
</div>

<!-- Kind of a lazy way to do this -->
<div class="inline w-100" *ngIf="fillParentWidth && !isLoading && sanitizedURL" data-cy="file-manager-image-fill-width">
  <img [class.roundcorners]="roundCorners" [class.round]="roundImage"
       style="background-size:contain"
       [src]="sanitizedURL"
       (error)="show = false; markDocumentAsDeleted()"
       class="file-preview-image w-100"
       data-cy="file-manager-image-fill-width-img" />
</div>

<div class="inline" *ngIf="resizable && !isLoading && sanitizedURL" data-cy="file-manager-image-resizable">
  <img [src]="sanitizedURL" class="w-100 h-100" data-cy="file-manager-image-resizable-img" />
</div>
